export default __webpack_public_path__ + "static/User-Feedback-Loop-a529e077a4b7139e04a8725bb2c8cb0a.webp";